// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { LEGAL_INFO_CLASS_NAME } from "../../../../core/constants/className";
import {
    T_FOOTER_COPYRIGHT,
    T_FOOTER_DESIGN,
    T_FOOTER_IMPLEMENTATION
} from "../../../../core/constants/translation";
import {
    COMPANY_NAME,
    CURRENT_YEAR,
    DESIGN_COMPANY_NAME,
    DESIGN_COMPANY_WEBSITE,
    IMPLEMENTATION_COMPANY_NAME,
    IMPLEMENTATION_COMPANY_WEBSITE
} from "../../../../core/constants/company";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./LegalInfo.scss";

export interface LegalInfoProps {
    readonly className?: string;
    readonly t: TranslationFunction;
}

export function LegalInfo (props: LegalInfoProps) {
    const t = props?.t;
    const className = props?.className;
    return (
        <div
            className={
                LEGAL_INFO_CLASS_NAME
                + (className ? ` ${className}` : '')
            }
        >

            <div className={LEGAL_INFO_CLASS_NAME + '-copyright'}>{t(T_FOOTER_COPYRIGHT, {
                CURRENT_YEAR,
                COMPANY_NAME
            })}</div>

            <div className={LEGAL_INFO_CLASS_NAME + '-design'}><a
                className={LEGAL_INFO_CLASS_NAME + '-design-link'}
                href={DESIGN_COMPANY_WEBSITE}
            >{t(
                T_FOOTER_DESIGN)} {DESIGN_COMPANY_NAME}</a></div>

            <div className={LEGAL_INFO_CLASS_NAME + '-implementation'}><a
                className={LEGAL_INFO_CLASS_NAME + '-implementation-link'}
                href={IMPLEMENTATION_COMPANY_WEBSITE}
            >{t(
                T_FOOTER_IMPLEMENTATION)} {IMPLEMENTATION_COMPANY_NAME}</a></div>

        </div>
    );
}
